// extracted by mini-css-extract-plugin
export default {"control":"Control_control__EdXUU","selected":"Control_selected__N4F6L"};